/**
 * @fileoverview Feedback UI — the English (EN) bundle (SAVE-FEEDBACK-CANON-001 P3).
 * @package @puffin-core/feedback-ui
 *
 * Born on the namespace mechanism: `feedbackUi`, registered once for every app by
 * `@puffin-core/i18n-namespaces`, so no host wires any copy. The sibling `es.js` is the Spanish bundle
 * and `_meta.js` records the provenance of every leaf in both.
 *
 * Three leaves, each the default a primitive renders when its host passes nothing: the dismiss control's
 * accessible name, the new-tab link's screen-reader sentence, and the error summary's heading. They
 * moved here VERBATIM from page-shell's `shell` bundle (`common.close`, `common.opensInNewTab`,
 * `errorSummary.title`) when the primitives did; page-shell keeps `common.close` for its own chrome.
 * No placeholders.
 *
 * PERMISSIONS-CANON-001 S11 (B4 / B5) added two access-refusal leaves (`securityRefusal.js`): the way past a location
 * the person is not assigned to, and past an app the account does not hold.
 */

export const FEEDBACK_UI_EN = Object.freeze({
  close: 'Close',
  opensInNewTab: '(opens in a new tab)',
  errorSummaryTitle: 'Fix these before saving',
  // PERMISSIONS-CANON-001 S11 (B4 / B5): two access refusals worded with the way past them (`securityRefusal.js`).
  refusalLocationForbidden:
    'You are not assigned to this location. Ask an administrator to add you to it.',
  refusalAppNotEntitled:
    'Your account does not include this app. Someone who manages the account can add it on the Apps and billing page.',
});
